import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import toaster from 'react-hot-toast';
import { CallHistoryData, getCallHistoryData } from 'api/assist/getCallHistoryData';
import { ApiError } from 'types/api';

export const useCallHistoryDataEndpoint = (
  businessId: number,
  startDate: string,
  endDate: string,
) => {
  const {
    isLoading,
    error,
    data = [],
    refetch,
  } = useQuery<unknown, ApiError, CallHistoryData>({
    queryKey: ['getCallHistoryData', startDate, endDate, businessId],
    queryFn: async () => {
      const response = await getCallHistoryData(businessId, startDate, endDate);
      return response.data ?? {};
    },
    retry: 1,
    onError: (error) => {
      Sentry.captureException(error);

      toaster(
        error?.response?.data?.error ??
          'An error occurred while fetching Cents Assist Call History data',
        {
          icon: '❌',
        },
      );
      return error;
    },
  });

  return {
    isLoading,
    error,
    data,
    refetch,
  };
};
